import { Box, Container, Grid } from "@mui/material";
import { Banknote, Truck, BadgeDollarSign, UserPlus } from "lucide-react";
import SectionTitle from "../UI/SectionTitle";
import StepCard from "../UI/StepCard";

const steps = [
  {
    number: "1",
    icon: <UserPlus size={40} />, // Represents joining/signing up
    title: "Join RSC",
    description:
      "Sign up and get instant access to selling opportunities with the best market rates.",
  },
  {
    number: "2",
    icon: <BadgeDollarSign size={40} />, // Represents receiving an offer
    title: "Get an Offer Within 24 Hours",
    description:
      "Tell us what you’re selling and receive a competitive offer—no waiting, no haggling.",
  },
  {
    number: "3",
    icon: <Truck size={40} />, // Represents shipping items
    title: "Ship Your Items",
    description:
      "Send your items with our prepaid shipping labels, or schedule a pickup.",
  },
  {
    number: "4",
    icon: <Banknote size={40} />, // Represents getting paid
    title: "Get Paid Fast",
    description:
      "Receive secure cash payments quickly—no delays, no uncertainty.",
  },
];

export default function HowItWorks() {
  return (
    <Box sx={{ py: 8, bgcolor: "background.paper" }} id="how-it-works">
      <Container>
        <SectionTitle
          title="How It Works"
          subtitle="Get started in 4 simple steps"
        />
        <Grid container spacing={4}>
          {steps.map((step, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <StepCard {...step} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
